import { RegionType } from "graphql/generated";

import { IS_PRODUCTION } from "./configs/common";

const host = process.env.NEXT_PUBLIC_SERVER_HOST;
const useSSL = process.env.NEXT_PUBLIC_SERVER_USE_SSL === "true" || false;
const httpProtocol = useSSL ? "https" : "http";
const wsProtocol = useSSL && IS_PRODUCTION ? "wss" : "ws";

export const config = {
  GRAPHQL_HTTP_URI: `${httpProtocol}://${host?.replace("localhost", "127.0.0.1")}/graphql`,
  HTTP_URI: `${httpProtocol}://${host}`,
  API_URI: `${httpProtocol}://${host}/${process.env.NEXT_PUBLIC_API_VERSION || "v1"}`,
  WS_URI: `${wsProtocol}://${host}/graphql`,
  COOKIES: {
    COOKIES: "cookies",
    ACCESS_TOKEN: "Authentication",
    REFRESH_TOKEN: "Refresh",
    IDENTIFY_USER: "User",
    LOCALE: "locale",
    NEXT_LOCALE: "NextLocale",
    NEXT_AUTH_SESSION_TOKEN: "__Secure-next-auth.session-token",
    NEXT_AUTH_CALLBACK_URL: "__Secure-next-auth.callback-url"
  },
  WEBFLOW_URLS: {
    [RegionType.Sg]: "https://www.ofnoah.sg/",
    [RegionType.Hk]: "https://www.ofnoah.hk/",
    [RegionType.Jp]: "https://www.ofnoah.jp/"
  }
};

export const EMAIL_WHITE_LIST = [
  "ethel@ofnoah.com",
  "ethel@ordinaryfolk.health",
  "duydlam@ordinaryfolk.health",
  "yijun@ordinaryfolk.health",
  "angeline@ordinaryfolk.health"
];

export const OPS_EMAIL_WHITE_LIST = ["angeline@ordinaryfolk.health"];

export const ENABLE_NEW_PRESCRIPTION_FLOW = true;

export const shouldHiddenIntercom = (pathName: string): boolean =>
  ["/ops", "/doctor", "/consult-video-call"].some((item) => pathName.includes(item));
